export default __webpack_public_path__ + "static/media/firstIconRight.f80af235.svg";